import {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import ReactGA from "react-ga4"

const RouteChangeTracker = () => {
    const location = useLocation();
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        // if (!window.location.href.includes("localhost")) {
        // 환경 변수 사용
        ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID, {
            debug: true,
        });
        // }
        setInitialized(true);
    }, []);

    useEffect(() => {
        if (initialized) {
            ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
        }
    }, [initialized, location]);
}

export default RouteChangeTracker;